
/* CRO: Malalo - geselecteerde filterwaarden als badges */

(() => {
  function updateBadges(form) {
    const sections = form.querySelectorAll(
      '.facets__accordion-section'
    );

    sections.forEach(section => {
      const badge = section.querySelector('.malalo-facet-badge');
      const filter = section.querySelector('.js-filter');

      if (!badge || !filter) return;

      let text = '';

      // Prijsfilter
      const priceRange = filter.querySelector('price-range');

      if (priceRange) {
        const fields = priceRange.querySelectorAll(
          'input[type="number"]'
        );

        if (fields.length === 2) {
          const slider = filter.querySelector('malalo-price-slider');
          const cap = Number(slider?.dataset.priceCap) || 200;

          const min = fields[0].value === ''
            ? 0
            : Number(fields[0].value);

          const max = fields[1].value === ''
            ? cap
            : Number(fields[1].value);

          const format = number =>
            new Intl.NumberFormat('nl-NL', {
              maximumFractionDigits: 2
            }).format(number);

          if (
            Number.isFinite(min) &&
            Number.isFinite(max) &&
            (min !== 0 || max !== cap)
          ) {
            text = `€ ${format(min)} – € ${format(max)}`;
          }
        }
      } else {
        // Overige filters: kleur, beschikbaarheid, type, enz.
        const selected = Array.from(
          filter.querySelectorAll('input[type="checkbox"]:checked')
        );

        if (selected.length === 1) {
          const container = selected[0].closest('.checkbox');

          const label = container?.querySelector(
            '.checkbox__label'
          ) || container?.querySelector('label:last-of-type');

          text = label?.textContent.trim() || selected[0].value;
        } else if (selected.length > 1) {
          text = `${selected.length} geselecteerd`;
        }
      }

      // Alleen wijzigen wanneer nodig
      if (badge.textContent !== text) {
        badge.textContent = text;
      }

      badge.hidden = !text;
    });

    // CRO: Malalo - aantal actieve filtergroepen

    const activeFilterCount = Array.from(sections).filter(
      section => {
        const badge = section.querySelector(
          '.malalo-facet-badge'
        );

        return badge && !badge.hidden;
      }
    ).length;

    const counter = form.querySelector(
      '.malalo-filter-count'
    );

    if (counter) {
      const nextValue = String(activeFilterCount);

      if (counter.textContent !== nextValue) {
        counter.textContent = nextValue;
      }

      counter.hidden = activeFilterCount === 0;
    }
  }


  function initialize() {
    const form = document.getElementById('FacetFiltersForm');

    if (!form || form.dataset.malaloBadgesReady === 'true') {
      return;
    }

    form.dataset.malaloBadgesReady = 'true';

    form.addEventListener('input', () => updateBadges(form));
    form.addEventListener('change', () => updateBadges(form));

    // Opnieuw bijwerken wanneer Shopify filters via AJAX ververst
    const observer = new MutationObserver(() => {
      updateBadges(form);
    });

    observer.observe(form, {
      childList: true,
      subtree: true
    });

    updateBadges(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }
})();
